import { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface BentoGridProps {
    children: ReactNode;
    className?: string;
}

interface BentoItemProps {
    children: ReactNode;
    className?: string;
    span?: 1 | 2 | 3 | 'full';
}

export function BentoGrid({ children, className }: BentoGridProps) {
    return (
        <div className={cn("grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[minmax(180px,auto)]", className)}>
            {children}
        </div>
    );
}

export function BentoItem({ children, className, span = 1 }: BentoItemProps) {
    const spanClasses = {
        1: "md:col-span-1",
        2: "md:col-span-2",
        3: "md:col-span-3",
        'full': "md:col-span-full"
    };

    return (
        <div className={cn(spanClasses[span], "h-full", className)}>
            {children}
        </div>
    );
}
